import {ToMatchOptions} from '../../Shared/utilities/MapDiscriminatedUnion';

export class InvalidPhoneNumber {
  public static create(phoneNumber: string) {
    return new InvalidPhoneNumber(phoneNumber);
  }
  public readonly key = 'InvalidPhoneNumber';
  public readonly validationError = 'Please enter a valid phone number.';

  private constructor(public readonly phoneNumber: string) {}
}

export class ValidPhoneNumber {
  public static create(phoneNumber: string) {
    if (phoneNumber.length > 10) {
      phoneNumber = phoneNumber.replace(/\D/g, '').slice(1);
    }
    const isValid = /^\d{10}$/.test(phoneNumber);

    return isValid || phoneNumber.length === 0
      ? new ValidPhoneNumber(phoneNumber)
      : InvalidPhoneNumber.create(phoneNumber);
  }

  public readonly key = 'ValidPhoneNumber';
  constructor(public readonly phoneNumber: string) {}
}

export type PhoneNumber = ValidPhoneNumber | InvalidPhoneNumber;

export type PhoneOptions<TReturn> = ToMatchOptions<PhoneNumber, 'key', TReturn>;

export const matchPhoneNumber = <TReturn>(phoneNumber: PhoneNumber, options: PhoneOptions<TReturn>): TReturn => {
  switch (phoneNumber.key) {
    case 'InvalidPhoneNumber':
      return options.InvalidPhoneNumber(phoneNumber);
    case 'ValidPhoneNumber':
      return options.ValidPhoneNumber(phoneNumber);
  }
};

export const EmptyPhoneNumber = new ValidPhoneNumber('');

export const isValidPhoneNumber = (phone: PhoneNumber): phone is ValidPhoneNumber => phone.key === 'ValidPhoneNumber';
